<template>
  <div class="wrapper" v-bind:class="sidebarOpen === true ? ' sidebar-open' : ''">
    <header class="main-header">

      <!-- Menu toggle -->
      <a class="sidebar-toggle" data-toggle="push-menu" role="button" @click="sidebarToggle()">
        <span class="sr-only">Toggle navigation</span>
      </a>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName"
             :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->

  </div>
  <!-- ./wrapper -->
</template>

<script>
import faker from 'faker'
import { mapState } from 'vuex'
import Sidebar from './Sidebar'
import 'hideseek'
import EventBus from '../store/eventBus'

export default {
  name: 'Dash',
  components: {
    Sidebar,
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      error: '',
      sidebarOpen: false,
    }
  },
  computed: {
    ...mapState([
      'userInfo',
    ]),
    demo () {
      return {
        displayName: faker.name.findName(),
        avatar: faker.image.avatar(),
        email: faker.internet.email(),
        randomCard: faker.helpers.createCard(),
      }
    },
  },
  mounted: function () {
    var $t = this
    EventBus.$on('closeMenu', function () {
      $t.sidebarOpen = false
    })
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    sidebarToggle () {
      this.sidebarOpen = this.sidebarOpen !== true
    },
  },
}
</script>

<style lang="scss">

@import '../scss/variables';

.wrapper {
  .main-header {
    position: fixed;
    background-color:transparent;
    width:auto;
    padding:15px 0;
    height:auto;
    a.logo, a.logo:hover {
      background: none;
    }
  }

  .content-wrapper {
    min-height: 100vh !important;
    background-color:white;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
    background-color:$suez-blue;
    padding-top:80px;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini, .logo-lg {
  text-align: center;

}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width:auto;
    max-height:40px;
  }
}
.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.content-header {
  background-color:white !important;
  padding-bottom: 15px;

  h1 {
    color: $suez-blue;
    font: 28px 'DinCondMedium';
  }
}

.sidebar-toggle {
  display: none;
}
.wrapper {
  background-color: $suez-blue !important;
}

@media (max-width: 767px) {
  .wrapper {
    .main-header {
      width: 100%;
      z-index: 1000;
      background-color: $suez-blue !important;
      .logo {
        width: auto !important;
        float: left !important;
      }
      .sidebar-toggle {
        display: inline;
        float: right !important;
        color: $suez-green-yellowish;
        padding: 10px 15px;
        margin: 5px 10px;
        border-radius: 5px;
        &:before {
          font-size: 18px;
        }
        &:hover {
          background-color: $suez-green-yellowish;
          color: $suez-blue;
        }
      }
    }
  }
  .content-wrapper {
    margin-top: 80px;
  }

}
</style>



// WEBPACK FOOTER //
// Dash.vue?30266e1b